module.exports = __webpack_public_path__ + "img/dashboard_arrow.0dd55efb.svg";